<ng-container *ngIf="(estaEnLinea$ | async) === false">
  <div class="fixed top-0 inset-x-0 z-[9999] w-full">
    <div class="bg-red-600 text-white px-4 py-2 text-sm flex items-center justify-between shadow pt-[env(safe-area-inset-top)]">
      <div class="flex items-center gap-2 mx-auto">
        <span class="inline-block h-2 w-2 rounded-full bg-white animate-pulse"></span>
        <span>Sin conexión a internet.</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="mostrarReconectado">
  <div class="fixed top-0 inset-x-0 z-[9999] w-full">
    <div class="bg-emerald-600 text-white px-4 py-2 text-sm flex items-center justify-between shadow pt-[env(safe-area-inset-top)]">
      <div class="flex items-center gap-2 mx-auto">
        <span class="inline-block h-2 w-2 rounded-full bg-white"></span>
        <span>Conexión restablecida.</span>
      </div>
    </div>
  </div>
</ng-container>
